import { ValueType } from "@/enums/ValueType";
import { MortgagePartFieldType } from "@/models/Leningdeel";
import { formatNumericWhole, formatNumericPercentage } from "./inputHelpers";

/**
 * Format a field in a Leningdeel for display
 *
 * @param fieldName - The name of the field to format
 * @param value - The value to format
 * @returns The formatted value
 */
export function formatField(
	fieldName?: keyof typeof MortgagePartFieldType,
	value?: string | number,
) {
	if (!fieldName) {
		return undefined;
	}

	const valueType = MortgagePartFieldType[fieldName];

	if (valueType === undefined) {
		return undefined;
	}

	switch (valueType) {
		case ValueType.Currency:
		case ValueType.Number:
			return formatNumericWhole(value);
		case ValueType.Percentage:
			return `${formatNumericPercentage(typeof value === "number" ? value * 100 : value)}%`;
		default:
			return value;
	}
}

export type ShortMortgageType =
	| "annuïteit"
	| "lineair"
	| "aflossingsvrij"
	| "spaar"
	| "leven"
	| "overig";

export function getShortMortgageType(type?: string): ShortMortgageType {
	switch (type) {
		case "Annuïteitenhypotheek":
		case "annuity":
			return "annuïteit";
		case "Lineaire hypotheek":
		case "linear":
			return "lineair";
		case "Aflossingsvrije hypotheek":
		case "interest-only":
			return "aflossingsvrij";
		case "Bankspaar- of spaarhypotheek":
		case "savings-mortgage":
			return "spaar";
		case "BEW- of beleggingshypotheek":
		case "life-insurance":
		case "investment-mortgage":
			return "leven";
		default:
			return "overig";
	}
}
